import { Card, Group, Icon, Stack, Text, Title } from "@assetwatch/ui";

interface AssetsV2MetricCardProps {
  icon: "asset" | "maintenance" | "wifi";
  label: string;
  value: string;
  description: string;
  iconClass: string;
}

export function AssetsV2MetricCard({
  icon,
  label,
  value,
  description,
  iconClass,
}: AssetsV2MetricCardProps) {
  return (
    <Card padding="comfortable" fillHeight>
      <Group align="start" gap={16} wrap="nowrap">
        <span
          className={`flex size-(--spacing-64) shrink-0 items-center justify-center rounded-full ${iconClass}`}
        >
          <Icon name={icon} size="lg" />
        </span>
        <Stack gap={8}>
          <div className="uppercase">
            <Text size="sm" tone="subtle">
              {label}
            </Text>
          </div>
          <span className="tabular-nums">
            <Title as="span" size="xl">
              {value}
            </Title>
          </span>
          <Text size="sm" tone="subtle">
            {description}
          </Text>
        </Stack>
      </Group>
    </Card>
  );
}
